import { Box } from "@mui/system";
import { ReactElement } from "react";
import VendorsDataGrid from "../hooks/vendors/vendorsDataGrid";

/**
 *
 * @returns {ReactElement} Nerd route
 */
export default function VendorsRoute(): ReactElement {
  return (
    <Box sx={{ p: 1, display: "flex", flex: 1 }}>
      <VendorsDataGrid />
    </Box>
  );
}
